// Single source of truth for the "[Note reply <uuid>]" token embedded at the
// front of a user message when they reply to an AI note. ChatWindow builds it
// (for display + persistence in the chat history); MessageBubble parses it back
// into a pill. Keeping the format here means the two never drift.

// Canonical UUID shape (8-4-4-4-12), not just "36 hex/hyphen chars".
const NOTE_REPLY_RE =
  /^\[Note reply ([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})\]\s*/;

/** Prefix the user's text with the note-reply token. */
export function buildNoteReplyContent(noteId: string, text: string): string {
  return `[Note reply ${noteId}] ${text}`.trim();
}

/**
 * Strip a leading note-reply token off a message. Returns the referenced note
 * id (or null when absent) and the remaining user text.
 */
export function parseNoteReplyContent(content: string): {
  noteId: string | null;
  text: string;
} {
  const match = content.match(NOTE_REPLY_RE);
  if (!match) return { noteId: null, text: content };
  return { noteId: match[1], text: content.slice(match[0].length) };
}
